// DO staging (do-sgp1-pitchin-staging-uat), served from do-staging.pitchin.dev.
//
// Deliberately SEPARATE from environment.staging2.ts: CircleCI builds staging2
// on every push to the staging branch for the AZURE staging deployment
// (staging.api.pitchin.dev). Reusing it for DO would repoint Azure staging at
// this cluster on the next merge.
//
// Every host here MUST stay same-origin on do-staging.pitchin.dev. The IEO (TCF)
// app is mounted at /token on this host and reads the ECF session from COOKIES;
// the gateway strips the Domain attribute from every proxied Set-Cookie, so a
// cross-origin apiServer leaves the session on the API host where /token can
// never send it -- a 400 on /api/ieo/Users/refresh-token and a page that shows
// "Log In" while the ECF app looks signed in.
export const environment = {
    production: false,
    emailAllowPlusSymbol: true,
    environment: 'DO_STAGING',
    //apiServer: 'https://staging.api.equity.pitchin.dev/',
    apiServer: 'https://do-staging.pitchin.dev/',
    baseUrl: 'https://do-staging.pitchin.dev',
    firebase: {
        apiKey: "AIzaSyAIbACcYssRqfzuTCrN6xliPS32Vn-iZ1w",
        authDomain: "pitchin-1e23a.firebaseapp.com",
        projectId: "pitchin-1e23a",
        storageBucket: "pitchin-1e23a.appspot.com",
        messagingSenderId: "407478835893",
        appId: "1:407478835893:web:15764b6c7b7dcb7326bcfc",
        measurementId: "G-1GYHH067MM"
    },
    cokeeps: {
        publicKey: "85a40da8527f5133e486adac9f49366475567a76877672b1bf88e013c978c875",
        hostEndpoint: "https://pitchin-api.cokeeps.org"
    },
    publicAPIKey: "BLLhehL-8FOy21ekjfff5sBp8s72MDU9j93hYM-gI-ZEwu2slvrHPE0Y1u-GFEaQcZCof-yUtDlHr18zB9NAr48",
    googleTagId: "GTM-K4VXHR9V",
    sentryDsn: "https://420560e3956846bfad663f1116de5478@o4504445196697600.ingest.sentry.io/4504445208494080",
    signalRUrl: "https://do-staging.signalr.pitchin.dev/ctosHub",
    signalRMarketUrl: "https://do-staging.signalr.pitchin.dev/marketsHub",
    kycVersion: "1.0.0",
    cryptoPubKey: "-----BEGIN RSA PUBLIC KEY-----MIGJAoGBAMITRmTe88FiK87o8ATZdlHiLZYWb7At8eiZ/JS/4obUsExBopsJPFZn/lItErwhB73SWOkFPxZgs9IznpEgHs654wiqSiAub+VFpOvm4Whue3kEC7HMnp7Gpyd0ixDl+yDX53NzqKmN+tnj/ifFfPsGwroCwZ2Cpa9Iy1sZ1/3NAgMBAAE=-----END RSA PUBLIC KEY-----",
    prismicRepo: "pitchin-my",
    prismicAcessToken: "MC5aQUE3dUJBQUFDVUFjRThM.77-9HO-_ve-_vR_vv73vv73vv71lKkEx77-9We-_vTjvv70mIHAWCTgA77-9dUTvv73vv71-CO-_vQ",
    ieoBaseUrl: "https://do-staging.pitchin.dev/token",
    ieoApiServer: "https://do-staging.pitchin.dev/",
    cspSetting: `default-src 'self' *.pitchin.dev;
        img-src 'self' data: blob: https://*; 
        media-src 'self';
        font-src 'self' data: https://fonts.gstatic.com; 
        style-src 'self' 'unsafe-inline' https://fonts.googleapis.com; 
        script-src 'self' 'unsafe-eval' https://*.posthog.com; 
        connect-src 'self' https://*.prismic.io https://*.cokeeps.org https://*.pitchin.my https://*.pitchin.dev https://o4504445196697600.ingest.sentry.io https://*.rss2json.com https://firebaseinstallations.googleapis.com https://fcmregistrations.googleapis.com/ https://stagingecfstore.blob.core.windows.net/ wss://do-staging.signalr.pitchin.dev https://*.cloudflare.com https://*.cloudflareinsights.com https://*.posthog.com; 
        form-action 'self'; 
        frame-src 'self' https://*.pitchin.dev https://www.youtube.com https://player.vimeo.com https://www.canva.com https://gamma.app; 
        manifest-src 'self'; 
        worker-src 'self' blob:; 
        frame-ancestors 'self'; 
        script-src-elem 'self' 'unsafe-inline' https://simulator.fpx.uat.inet.paynet.my https://www.googletagmanager.com https://*.posthog.com https://*.cloudflare.com https://*.cloudflareinsights.com`,
    instrumentationId: '0c681e6f-e825-42cf-9544-271600eb8d98',
    surveyFormId: {
        investmentCancellation: "12W-EhC2vjxE28zs4dYuxg0-b_xEDDAE7aJEz2YnEQuA",
        refundRequest: "1lTxiZBKp3q6dg8juTTj1UdLXpX8zaVK2Edo8dykGDTg"
    },
    flagToShowPstx: true,
    flagToShowDuitNow: true,
    flagToShowTcfWalletManagement: true,
    flagToShowStatementsReports: true,
    flagToShow2fa: true,
    flagToUseCokeeps: false,
    flagToUsePitchinWallet: true,
    flagToShowCosif: true,
    flagToUseGammaAIEmbeddedContent: false,
    flagToUseNewInvestorList:true,
    // FRC-921: the investor distribution endpoints (FRC-903/904) ship in the
    // frc888-20260924 API image, so this stays OFF to exercise the real route.
    flagToUseDistributionMockData: false,
    //geminiImageApiUrl:"https://staging.api.equity.pitchin.dev/api/ImageGeneration",
    geminiImageApiUrl:"https://do-staging.pitchin.dev/api/ImageGeneration",
    flagToUseAutoGenerateZoomMeeting:true,
    flagToAutoGenerateImage:true,
    posthog: {
        apiKey: "phc_8H1Howji8VH6wl2ZSCkPaTjq9L2pR7l2FqD0CK9kTyF",
        apiHost: "https://app.posthog.com",
    },
};
